<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

defineProps<{
  isLoading: boolean;
  btnText: string;
}>();

const emits = defineEmits(["click"]);
</script>

<template>
  <button
    class="border border-brown rounded-lg"
    :class="{
      'opacity-25 pointer-events-none': isLoading,
    }"
    @click="emits('click')"
  >
    {{ btnText }}
  </button>
</template>
